import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { formatDate, dateTimeSaparator } from '../../../../helper/formatDate';
import {
    getWhatsAppAppUrl,
    getWhatsAppWebUrl,
    getStatusBadge,
    getServiceBadgeClass,
    getTrialStatus
} from '../EnquiryList/enquiryUtils';
import { FollowUpHistoryModal } from '../FollowUpHistoryModal';

export const CallLogMobileCard = ({ row, handleReport }) => {
    const enq = row.enquiry || {};
    const status = getStatusBadge(row.status);
    const serviceName = enq.course?.name || '';
    const serviceBadge = getServiceBadgeClass(serviceName);
    const trialStatus = getTrialStatus(enq.tryal_date, enq.tryal_period);

    const callDT = dateTimeSaparator(row.created_at);
    const appUrl = getWhatsAppAppUrl(enq.whatsapp, enq.phone, enq.name);
    const webUrl = getWhatsAppWebUrl(enq.whatsapp, enq.phone, enq.name);

    return (
        <div className="card border shadow-none mb-2 rounded-3 w-100 overflow-hidden">
            {/* Header: School Name, Status & Trial */}
            <div className="card-header bg-light-subtle py-2 px-3 border-bottom d-flex align-items-center justify-content-between flex-wrap gap-2">
                <div style={{ minWidth: 0, maxWidth: '70%' }}>
                    <span
                        role="button"
                        onClick={() => handleReport && handleReport(row)}
                        className="fw-bold text-dark fs-14 text-truncate d-block school-name-link cursor-pointer"
                    >
                        {enq.name || 'Candidate / School'}
                    </span>
                    <div className="d-flex align-items-center gap-1.5 mt-0.5 flex-wrap">
                        {trialStatus && (
                            <span className={`badge ${trialStatus.badgeClass} fs-10 px-1.5 py-0.5`}>
                                {trialStatus.label}
                            </span>
                        )}
                        {serviceName && (
                            <span className={`service-pill-badge ${serviceBadge} fs-10`}>
                                {serviceName}
                            </span>
                        )}
                    </div>
                </div>
                <span className={`badge bg-soft-${status.color} text-${status.color} fs-11 px-2 py-0.5 fw-semibold`}>
                    {row.status === 'deleted' ? 'Not Interested' : status.label}
                </span>
            </div>

            {/* Body: Contact, Remark, Time & Next Date */}
            <div className="card-body p-3">
                {/* Phone & Call Time */}
                <div className="d-flex align-items-center justify-content-between mb-2 fs-12">
                    <a
                        href={`tel:${enq.phone}`}
                        className="text-success fw-semibold text-decoration-none d-inline-flex align-items-center"
                    >
                        <i className="bx bx-phone me-1 fs-14" />
                        {enq.phone || 'N/A'}
                    </a>
                    <span className="text-muted d-inline-flex align-items-center gap-1 fs-11">
                        <i className="ri-time-line" />
                        {callDT.time || callDT.date || 'N/A'}
                    </span>
                </div>

                {/* Remark Box */}
                <div
                    className="p-2 bg-light-subtle rounded border border-light-subtle fs-12 text-body lh-sm mb-2"
                    style={{ whiteSpace: 'pre-wrap' }}
                >
                    {row.remark || <span className="text-muted fst-italic">No remarks logged.</span>}
                </div>

                {/* Next Date & Actions */}
                <div className="d-flex align-items-center justify-content-between pt-2 border-top border-light-subtle flex-wrap gap-2 fs-12">
                    <div>
                        {row.nextDate ? (
                            <span className="text-primary fw-medium d-inline-flex align-items-center gap-1">
                                <i className="ri-calendar-check-line" />
                                <span>Next:</span>
                                <strong>{formatDate(row.nextDate)}</strong>
                            </span>
                        ) : (
                            <span className="text-muted fs-11 fst-italic">No next date</span>
                        )}
                    </div>

                    <div className="d-flex align-items-center gap-1">
                        {/* WhatsApp Dropdown */}
                        {(appUrl || webUrl) && (
                            <Dropdown align="end" className="d-inline-block">
                                <Dropdown.Toggle
                                    variant="soft-success"
                                    size="sm"
                                    className="py-1 px-2 border-0 arrow-none d-inline-flex align-items-center"
                                >
                                    <i className="ri-whatsapp-line fs-13 text-success" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="shadow border-0 py-1" style={{ minWidth: '170px' }}>
                                    <Dropdown.Item href={appUrl} className="fs-12 py-1">WhatsApp App</Dropdown.Item>
                                    <Dropdown.Item href={webUrl} target="_blank" rel="noopener noreferrer" className="fs-12 py-1">WhatsApp Web</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        )}

                        {/* History Modal */}
                        <FollowUpHistoryModal enquiryId={enq.id} schoolName={enq.name}>
                            <button className="btn btn-sm btn-soft-primary py-1 px-2" title="View Full History">
                                <i className="ri-chat-3-line fs-13" />
                            </button>
                        </FollowUpHistoryModal>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CallLogMobileCard;
